import { Box, Container, Stack } from "@mui/material";
import React, { FormEvent, useState } from "react";

import hideEye from "../../assets/svgs/eye-password-hide.svg";
import showEye from "../../assets/svgs/eye.svg";
import {
  Button,
  InputField,
  Link,
  PaperSurface,
  Text,
} from "components/common";
import { useSignIn } from "hooks";
import { UNATH_ROUTER_PATHS } from "types/navigation";
import PopUpMessage from "components/common/PopUpMessage/PopUpMessage";

interface OwnProps {}

type TSignIn = OwnProps;

export const SignIn: React.FC<TSignIn> = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [popupOpen, setPopupOpen] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { error, loading: signInLoading, signIn } = useSignIn();
  const [errorMsg, setErrorMsg] = useState("");

  const handleFormSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (email.length > 0 && password.length > 0) {
      await signIn(email, password);
    }
    if (error) {
      setPopupOpen(true);
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <Stack alignItems="center">
          <Text variant="h4" fontWeight={500} sx={{ marginBottom: "20px" }}>
            Sign in
          </Text>
          <PaperSurface
            elevation={3}
            sx={{
              padding: "45px 40px",
              width: "100%",
              borderRadius: "15px",
            }}
          >
            <form onSubmit={handleFormSubmit}>
              <Stack spacing={2}>
                <InputField
                  label="Email"
                  type="email"
                  variant="outlined"
                  required
                  value={email}
                  onChange={setEmail}
                />
                <Box
                  sx={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center !important",
                  }}
                >
                  <InputField
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    required
                    value={password}
                    onChange={setPassword}
                  />
                  <div
                    style={{ marginTop: "34px", cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <img src={hideEye} alt="" style={{ width: "20px" }} />
                    ) : (
                      <img src={showEye} alt="" style={{ width: "20px" }} />
                    )}
                  </div>
                </Box>
                <Button
                  style={{
                    backgroundColor: "#FFE500",
                    color: "black",
                    fontWeight: "600",
                    borderRadius: "50px",
                    boxShadow: "none",
                  }}
                  variant="contained"
                  type="submit"
                  disabled={signInLoading}
                >
                  Continue
                </Button>
              </Stack>
            </form>
          </PaperSurface>
          <Box sx={{ marginTop: "15px" }}>
            <Link path={UNATH_ROUTER_PATHS.RESET_PASSWORD}>
              <Text>I forgot my password</Text>
            </Link>
          </Box>
        </Stack>
      </Container>
      <PopUpMessage
        isOpen={popupOpen && !!error}
        type="error"
        message={
          error?.response?.data?.payload?.message ||
          "Please enter both email and password."
        }
        buttonText="OK"
        onOkClick={() => setPopupOpen(false)}
      />
    </Box>
  );
};
